import styled from 'styled-components'

export const FlexColumnAtom = styled.div<{ $gap?: number, $width?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap ?? 8}px;
  width: ${({ $width }) => $width};
`
